import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { RouterLink } from '@angular/router';
import { provideTranslocoScope, TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { ShortNumberPipe } from '@rma/generic/util/short-number';
import { PROPERTY_TYPES_TRANSLATION_KEY } from '@rma/public/generic/domain/types';
import { SkeletonGridComponent } from '@rma/public/generic/ui/skeleton';
import { ApiToTranslationPipe } from '@rma/public/generic/util/pipes/api-to-translation';
import { COMPARE_AGENT_SCOPE } from '../domain/translation-scope';
import { ComparisonTableComponent } from './comparison-table.component';
import { ComparisonTableCellComponent } from './comparison-table-cell.component';
import { ComparisonTableRowComponent } from './comparison-table-row.component';
import { SalesPerformanceDetails, showsSalesPerformanceValue, visibleSalesPerformanceRows } from './sales-performance-rows';

export type { SalesPerformanceDetails } from './sales-performance-rows';

@Component({
  selector: 'rma-sales-performance-section',
  templateUrl: './sales-performance-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope(COMPARE_AGENT_SCOPE, PROPERTY_TYPES_TRANSLATION_KEY)],
  imports: [
    ApiToTranslationPipe,
    ComparisonTableCellComponent,
    ComparisonTableComponent,
    ComparisonTableRowComponent,
    DecimalPipe,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    RouterLink,
    ShortNumberPipe,
    SkeletonGridComponent,
    TranslocoDirective,
    TranslocoPipe,
  ],
  host: {
    class: 'block',
  },
})
export class SalesPerformanceSectionComponent {
  protected readonly scope = `${COMPARE_AGENT_SCOPE}.salesPerformance`;
  protected readonly propertyTypesScope = PROPERTY_TYPES_TRANSLATION_KEY;
  protected readonly showsValue = showsSalesPerformanceValue;
  protected readonly propertiesQueryParams = { statuses: 'Sold' };
  protected readonly rows = computed(() =>
    visibleSalesPerformanceRows(this.agents(), this.buyersAgentEnabled(), this.selectedPropertyType()),
  );

  readonly agents = input.required<readonly SalesPerformanceDetails[]>();
  readonly buyersAgentEnabled = input(false);
  readonly propertyTypes = input<readonly string[]>([]);
  readonly selectedPropertyType = input<string | null>(null);

  readonly propertyTypeChange = output<string | null>();
}
